import React, { useEffect, useRef } from "react";
import { X } from "lucide-react";

interface ModalWindowProps {
  isOpen: boolean;
  onClose: () => void;
  exhibitorSlug: string;
  librarySlug: string;
}

export const ModalWindow: React.FC<ModalWindowProps> = ({
  isOpen,
  onClose,
  exhibitorSlug,
  librarySlug,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  // URLを動的に生成
  const url = `https://jp.evort.com/presentations/${exhibitorSlug}/${librarySlug}/embed`;
  // const url = `http://localhost:3001/jp/ja/presentations/${exhibitorSlug}/${librarySlug}/embed`;

  // ESCキーでモーダルを閉じる
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      // スクロールを無効化
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      {/* オーバーレイ */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: `rgba(var(--overlay-color, 51, 51, 51), var(--modal-backdrop-opacity))`,
          zIndex: 9998,
          animation: "fadeIn 0.2s ease",
          cursor: "pointer",
        }}
      />

      {/* モーダルコンテナ */}
      <div
        className="modal-container"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%) scale(0.95)",
          width: "80%",
          maxWidth: "920px",
          height: "90vh",
          maxHeight: "800px",
          zIndex: 9999,
          animation: "slideIn 0.3s ease forwards",
        }}
      >
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          {/* 閉じるボタン（モーダル枠外の右上に配置） */}
          <button
            className="modal-close-button"
            onClick={onClose}
            style={{
              position: "absolute",
              top: "-36px",
              right: "-36px",
              width: "72px",
              height: "72px",
              borderRadius: "50%",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "background-color 0.2s ease",
              zIndex: 10001,
            }}
            onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(var(--overlay-color, 51, 51, 51), 0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
            }}
            aria-label="Close modal"
          >
            <X size={60} color="#fff" strokeWidth={1} />
          </button>

          {/* モーダル本体 */}
          <div
            ref={modalRef}
            style={{
              width: "100%",
              height: "100%",
              // backgroundColor: "white",
              // borderRadius: "16px",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* iframeコンテンツ（全面表示） */}
            <iframe
              src={url}
              title="Product Details"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                // borderRadius: "16px",
                backgroundColor: "transparent",
              }}
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>

      {/* アニメーション用のスタイル */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
          }
        }

        @media (max-width: 768px) {
          .modal-container {
            width: calc(100% - 20px) !important;
            margin: 10px !important;
            height: calc(100vh - 20px) !important;
            max-height: calc(100vh - 20px) !important;
          }
          
          .modal-close-button {
            top: 10px !important;
            right: 10px !important;
            width: 48px !important;
            height: 48px !important;
            background-color: rgba(var(--overlay-color, 51, 51, 51), var(--button-hover-opacity)) !important;
          }
          
          .modal-close-button svg {
            width: 32px !important;
            height: 32px !important;
          }
        }
      `}</style>
    </>
  );
};
